// 2023-11-28 - moved from formsviewer.domain.js

var ensureMember = function (obj, key, constructor) {
    var member = obj[key];

    if (!member) {
        member = new constructor();
        obj[key] = member;
    }

    return member;
};

function RuleSetByFieldCollection() {
    this._items = {};
}

// String -> Array[RuleSet]
RuleSetByFieldCollection.prototype.ensureRuleSetCollection = function (
    fieldName,
) {
    return ensureMember(this._items, fieldName, Array);
};

RuleSetByFieldCollection.prototype.getByFieldName = function (fieldName) {
    return this._items[fieldName];
};

function RuleSetByDataSourceCollection() {
    this._items = {};
}

// String -> Array[RuleSetByFieldCollection]
// Ensures that this collection has a RuleSetByFieldCollection with the key <dataSourceName>
// and returns it
RuleSetByDataSourceCollection.prototype.ensureByFieldCollection = function (
    dataSourceName,
) {
    return ensureMember(this._items, dataSourceName, RuleSetByFieldCollection);
};

RuleSetByDataSourceCollection.prototype.getByDsName = function (
    dataSourceName,
) {
    return this._items[dataSourceName];
};

export default RuleSetByDataSourceCollection;
